import { MultiSelect } from 'src/design/atoms/MultiSelect';
import React from 'react';

interface ICostCodeSelectorProps {
  value: string[] | null;
  onChange: (value: string[] | null) => void;
  options?: Array<{
    value: string;
    label: string;
  }>;
}

export const CostCodeSelector = React.memo(
  ({ onChange, value, options = [] }: ICostCodeSelectorProps) => {
    return (
      <MultiSelect
        label="Cost Code"
        placeholder="Select cost codes"
        value={value || []}
        onChange={(newValue) => onChange(newValue.length > 0 ? newValue : null)}
        data={options}
        searchable
        clearable
        style={{ width: 500 }}
      />
    );
  },
);
